<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet {{
		sectionclass
	}}"
>
	<div class="cards-holder devices-tab">
		<div class="card mRight devices-carousel creative-performance-stats display-creative-container">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div *ngIf="hasData && sortedCreatives.length > 0" class="ngu-carousel-container">
				<ngu-carousel
					#carousel
					[inputs]="carouselOne"
					(onMove)="onmoveFn($event)"
					(carouselLoad)="initDataFn($event)"
					[dataSource]="sortedCreatives"
				>
					<ngu-tile NguCarouselItem *nguCarouselDef="let creative" class="display-creative-header-v3">
						<div>
							<div>
								<div class="stats-container">
									<div class="title add-color">
										<h5 title="{{ creative?.creativeName }}" class="ellipses-2nd-line">
											<div class="creative-chart-header-text"></div>
											{{ creative?.creativeName }}
										</h5>
									</div>
									<div
										*ngIf="!creative?.isVideoCreative && !creative?.adHeadline && !creative?.isSocial"
										class="creative-thumbnail"
										(click)="openModal('display-creative-v3', creative)"
										[ngStyle]="{
											background: 'url(&quot;' + creative?.creativeThumbnail + '&quot;) no-repeat center center',
											'background-size': getCreativeSize(creative.creativeThumbnail)
										}"
									></div>
									<ng-template [ngIf]="!creative?.adHeadline && creative?.isSocial">
										<div
											*ngIf="creative?.creativeThumbnail && creative?.isIframeExpired === 0"
											class="creative-thumbnail social-img"
											(click)="openModal('display-creative-v3', creative)"
											[ngStyle]="{
												background: 'url(&quot;' + creative?.creativeThumbnail + '&quot;) no-repeat center center',
												'background-size': getCreativeSize(creative.creativeThumbnail)
											}"
										></div>
										<div
											*ngIf="
												creative?.snapshotImage &&
												creative?.snapshotImage !== 'null' &&
												creative?.snapshotImage !== '' &&
												creative?.isIframeExpired === 1
											"
											class="creative-thumbnail social-img"
											(click)="openModal('display-creative-v3', creative)"
											[ngStyle]="{
												background: 'url(&quot;' + creative?.snapshotImage + '&quot;) no-repeat center center',
												'background-size': getCreativeSize(creative.snapshotImage)
											}"
										></div>
										<div
											*ngIf="
												(creative?.isIframeExpired === 1 &&
													(!creative?.snapshotImage || creative?.snapshotImage == '')) ||
												(creative?.isIframeExpired === 0 && creative?.iframeUrl === null)
											"
											class="creative-thumbnail social-img"
											[ngStyle]="{
												background:
													'url(../../../../../../assets/images/no-creative-preview-r2.png) no-repeat center center',
												'background-size': getCreativeSize(creative.creativeThumbnail)
											}"
										></div>
									</ng-template>
									<div class="display-stats-container">
										<ul class="creative-stats display-stats">
											<li>
												<h5 class="stats">{{ creative?.impressions | number }}</h5>
												<span class="stats-label">IMPRESSIONS</span>
											</li>
											<li class="native-li">
												<div class="pills-div">
													<ul class="native-pills">
														<li>
															<div
																class="pill"
																[ngStyle]="{ background: graphData.series[0].color }"
																*ngIf="creative.isIAB"
															>
																IAB Display
															</div>
														</li>
														<li>
															<div
																class="pill"
																[ngStyle]="{ background: graphData.series[0].color }"
																*ngIf="creative.isNative"
															>
																Native
															</div>
														</li>
													</ul>
												</div>
											</li>
										</ul>
										<ul class="creative-stats display-stats" *ngIf="creative.isIAB">
											<li *ngIf="!creative?.isVideoCreative && !creative?.adHeadline && creative?.adInteractions">
												<h5 class="stats">{{ creative?.adInteractions | number }}</h5>
												<span class="stats-label">AD INTERACTIONS</span>
											</li>
											<li *ngIf="!creative?.isVideoCreative && !creative?.adHeadline && creative?.adInteractionRate">
												<h5 class="stats">{{ creative?.adInteractionRate | number: '0.1-2' }}%</h5>
												<span class="stats-label">AD INTERACTION RATE</span>
											</li>
										</ul>
										<ul class="creative-stats display-stats">
											<li class="">
												<h5 class="stats">{{ creative?.clicks | number }}</h5>
												<span class="stats-label">CLICKS</span>
											</li>
											<li *ngIf="creative?.clickRate">
												<h5 class="stats">{{ creative?.clickRate | number: '0.1-2' }}%</h5>
												<span class="stats-label">CLICK RATE</span>
											</li>
										</ul>
										<ul *ngIf="creative?.isSocial && creative?.percentRate25" class="creative-stats display-stats">
											<li class="">
												<h5 class="stats">{{ creative?.percentValue100 | number }}</h5>
												<span class="stats-label">COMPLETIONS</span>
											</li>
											<li *ngIf="creative?.percentRate100">
												<h5 class="stats">{{ creative?.percentRate100 | number: '0.1-2' }}%</h5>
												<span class="stats-label">COMPLETION RATE</span>
											</li>
										</ul>

										<ul *ngIf="creative?.isSocial" class="creative-stats display-stats">
											<li class="">
												<h5 class="stats">{{ creative?.engagements | number }}</h5>
												<span class="stats-label">ENGAGEMENTS</span>

												<div *ngIf="creative?.isSocial" class="engagement-container">
													<div class="creative-stats display-stats">
														<li class="">
															<h5 class="stats">{{ creative?.likes | number }}</h5>
															<span class="stats-label">LIKES</span>
														</li>
													</div>
													<div class="creative-stats display-stats">
														<li class="">
															<h5 class="stats">{{ creative?.shares | number }}</h5>
															<span class="stats-label">SHARES</span>
														</li>
													</div>

													<div class="creative-stats display-stats">
														<li class="">
															<h5 class="stats">{{ creative?.saves | number }}</h5>
															<span class="stats-label">SAVES</span>
														</li>
													</div>

													<div class="creative-stats display-stats">
														<li class="">
															<h5 class="stats">{{ creative?.comments | number }}</h5>
															<span class="stats-label">COMMENTS</span>
														</li>
													</div>
													<div class="creative-stats display-stats">
														<li class="">
															<h5 class="stats">{{ creative?.reactions | number }}</h5>
															<span class="stats-label">REACTIONS</span>
														</li>
													</div>
												</div>
											</li>
										</ul>
										<div
											class="preRoll-creative-completion-stats-scroll-div"
											*ngIf="creative?.isSocial && creative?.percentRate25 > 0"
										>
											<div class="preRoll-creative-completion-stats">
												<div class="preRoll-creative-header-content text-font-bold add-color">Started</div>
												<div class="preRoll-creative-views par-title-font add-color">
													100% / {{ creative.impressions | formatNumber }} Views
												</div>
												<div class="progressbar">
													<div class="primary-color-bg-right-gradient preroll-bg-right-gradient"></div>
												</div>
											</div>
											<div class="preRoll-creative-completion-stats">
												<div class="preRoll-creative-header-content text-font-bold add-color">25% Completed</div>
												<div class="preRoll-creative-views par-title-font add-color">
													{{ creative.percentRate25 }}% / {{ creative.percentValue25 | formatNumber }} Views
												</div>
												<div class="progressbar">
													<div
														class="primary-color-bg-right-gradient"
														[ngStyle]="getPercentage(creative.percentRate25)"
													></div>
												</div>
											</div>
											<div class="preRoll-creative-completion-stats">
												<div class="preRoll-creative-header-content text-font-bold add-color">50% Completed</div>
												<div class="preRoll-creative-views par-title-font add-color">
													{{ creative.percentRate50 }}% / {{ creative.percentValue50 | formatNumber }} Views
												</div>
												<div class="progressbar">
													<div
														class="primary-color-bg-right-gradient"
														[ngStyle]="getPercentage(creative.percentRate50)"
													></div>
												</div>
											</div>
											<div class="preRoll-creative-completion-stats">
												<div class="preRoll-creative-header-content text-font-bold add-color">75% Completed</div>
												<div class="preRoll-creative-views par-title-font add-color">
													{{ creative.percentRate75 }}% / {{ creative.percentValue75 | formatNumber }} Views
												</div>
												<div class="progressbar">
													<div
														class="primary-color-bg-right-gradient"
														[ngStyle]="getPercentage(creative.percentRate75)"
													></div>
												</div>
											</div>
											<div class="preRoll-creative-completion-stats">
												<div class="preRoll-creative-header-content text-font-bold add-color">100% Completed</div>
												<div class="preRoll-creative-views par-title-font add-color">
													{{ creative.percentRate100 }}% / {{ creative.percentValue100 | formatNumber }} Views
												</div>
												<div class="progressbar">
													<div
														class="primary-color-bg-right-gradient"
														[ngStyle]="getPercentage(creative.percentRate100)"
													></div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="clear"></div>
							</div>
							<div class="clear"></div>
						</div>
					</ngu-tile>

					<span NguCarouselPrev class="leftRs">
						<i class="fa fa-angle-left" aria-hidden="true"></i>
					</span>
					<span NguCarouselNext class="rightRs">
						<i class="fa fa-angle-right" aria-hidden="true"></i>
					</span>
				</ngu-carousel>
			</div>
			<div class="no-data-container" *ngIf="!hasData">
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
		<div class="card card3 mLeft" id="display-creative-v3-chart-container">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div *ngIf="!hasData">
				<img [src]="placeholderimage" class="no-creative-data" />
			</div>

			<div [hidden]="!hasData">
				<div class="c-portlet__header">
					<div class="o-stack__cell">
						<h5 class="creative-charts-header">
							<span *ngIf="removeKeysData && removeKeysData.length == 0">{{ sectiontitle }}</span>
							<span class="datatable-icon" *ngIf="hasData && downloadConfiguration?.enableDownload">
								<a
									href="javascript:void(0)"
									class="datatable_download_icon creative_download_icon"
									(click)="downloadCSV($event)"
									target="_blank"
								>
									<i class="fa fa-download" aria-hidden="true"></i>
								</a>
							</span>
							<span *ngIf="removeKeysData && removeKeysData.length > 0">GeoFence Daily Creative Comparison</span>
						</h5>
					</div>
				</div>
				<div class="performance-graph-area" #bubblechartcontainer>
					<div class="display-creative-v3-legend-area legend-area">
						<div class="legend1">
							<div
								class="legend_item"
								[ngClass]="{ legend_item_selected: legendItem.selected }"
								(click)="processSelectedLegendItem(legendItem)"
								*ngFor="let legendItem of legend"
							>
								{{ legendItem.displayName }}
							</div>
						</div>
					</div>
					<div class="bubblechartcontainer">
						<div
							class="display-creative-v3-area-chart"
							*ngFor="let chartData of graphSeriesData; let index = index"
							id="display-creative_{{ index }}"
						>
							<div class="creative-bubble-chart-text-cntr">
								<div class="creative-chart-header">
									<div class="creative-chart-header-text"></div>
									{{ chartData.series[0].name }}
								</div>
							</div>
							<div class="creative-bubble-chart-cntr">
								<div>
									<app-creative-performance-graph
										[sectiontitle]="sectiontitle"
										[legendData]="legend"
										[graphData]="chartData"
										(legendSelected)="processSelectedLegendItem($event)"
										[legendDisabled]="true"
										(mouseOutChart)="chartHover($event)"
										(mouseOverChart)="chartHover($event)"
										[svgWidth]="svgWidth"
										[ticksRotation]="'45'"
										[chartType]="'areaspline'"
										[name]="chartData.id"
									>
									</app-creative-performance-graph>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<app-modal id="display-creative-v3">
	<app-creative-ad-preview
		[creative]="selectedCreative"
		(modalClose)="closeModal('display-creative-v3')"
	></app-creative-ad-preview>
	<div class="modal-background"></div>
</app-modal>
